import { useInfiniteQuery } from 'react-query';

import { getAiThreads } from '@utils/backend-api/aiThread';

export const AI_THREADS_KEY = 'AI_THREADS';
export const SUGGESTED_THREADS_KEY = 'SUGGESTED_THREADS';

export default function useAiThreads({ perPage = 20 }) {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
    [AI_THREADS_KEY, perPage],
    async ({ pageParam = 1 }) => await getAiThreads({ page: pageParam, perPage }),
    {
      getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.page + 1 : undefined),
    }
  );

  const aiThreads = data?.pages.flatMap((page) => page.aiThreads) || [];

  return {
    aiThreads,
    isLoadingAiThreads: isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  };
}
